import { toBase64 } from '@/utils/base64'
import get from 'lodash/get'
export function encodeUrl(url) {
  try {
    const method = process.env.CDN_ORIGIN_ENCODING || 'url'
    const normalizedUrl = (url.startsWith('//')) ? `https:${url}` : url
    const filename = new URL(normalizedUrl).pathname.split('/').pop()
    switch (method) {
    case 'url':
      return encodeURIComponent(normalizedUrl)
    case 'base64':
      // include asset handle if available so we can more easily identify assets
      return `o=${toBase64(normalizedUrl)}?handle=${encodeURIComponent(filename)}`
    default:
      return encodeURIComponent(normalizedUrl)
    }
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(err)
      return url
    } else {
      throw err
    }
  }
}
export function getImgOptions(srcObj, options = {}) {
  const src = get(srcObj, 'src', '')
  let type = 'cloudflare'
  if (src.includes('ctfassets')) {
    type = 'contentful'
  } else if (src.includes('shopify')) {
    type = 'shopify'
  } else if (src.includes('blob:')) {
    type = 'blob'
  }
  return {
    ...options,
    src: (type === 'cloudflare') ? encodeUrl(src) : src,
    alt: options.alt,
    provider: type,
  }
}
export function getCacheUrl(url) {
  const cdnHost = process.env.CDN_DOMAIN
  const cachePath = `/api/v1/cache-proxy/${encodeUrl(url)}`
  return (cdnHost) ? `${cdnHost}${cachePath}` : cachePath
}
export const UrlFilters = {
  filters: {
    encodeUrl,
    cacheUrl(url) {
      return getCacheUrl(url)
    }
  },
  methods: {
    $getCacheUrl: getCacheUrl,
    $getImgUrl(src, modifiers, options = {}) {
      const $img = this.$img
      const imgOptions = { provider: 'cloudflare', ...options }
      const imgSrc = (imgOptions.provider === 'cloudflare') ? encodeUrl(src) : src
      return ($img && src) ? $img(imgSrc, modifiers, imgOptions) : src
    },
    $getImgOptions: getImgOptions
  }
}
